(() => {
  const phone = window.matchMedia('(max-width: 768px)');
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]';
  let previousFocus;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const opener = document.querySelector('[data-open-mobile-menu]');
  const quickView = document.querySelector('#FlexVibeQuickView');
  const search = document.querySelector('#FlexSearch');
  const cart = document.querySelector('cart-drawer');
  const gallery = document.querySelector('[data-gallery-lightbox]');
  const updateDescriptions = () => {
    document.querySelectorAll('[data-mobile-description]').forEach(details => {
      if (!details.dataset.userOpened) details.open = !phone.matches;
    });
  };
  updateDescriptions();
  phone.addEventListener('change', updateDescriptions);
  const buyingForm = document.querySelector('.fv-buy-box form[action*="/cart/add"]');
  if (buyingForm && 'IntersectionObserver' in window) {
    const buyingObserver = new IntersectionObserver(entries => {
      document.body.classList.toggle('fv-buying-in-view', entries[0].isIntersecting);
    }, { threshold: 0 });
    buyingObserver.observe(buyingForm);
  }
  document.querySelectorAll('[data-mobile-description] summary').forEach(summary => {
    summary.addEventListener('click', () => summary.parentElement.dataset.userOpened = 'true');
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-mobile-menu]')) {
      previousFocus = event.target.closest('[data-open-mobile-menu]');
      opener?.setAttribute('aria-expanded', 'true');
      drawer?.querySelector('[data-close-mobile-menu].fv-mobile-drawer-close')?.focus();
    }
    if (event.target.closest('[data-open-qv]')) previousFocus = event.target.closest('[data-open-qv]');
    if (event.target.closest('[data-open-search]')) previousFocus = event.target.closest('[data-open-search]');
    if (event.target.closest('[data-close-mobile-menu]') || event.target.closest('[data-mobile-drawer] a')) {
      if (drawer) drawer.hidden = true;
      opener?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (!event.target.closest('a')) opener?.focus();
    }
    if (event.target.closest('[data-close-quick],[data-close-search]')) previousFocus?.focus();
  });
  document.addEventListener('keydown', event => {
    const dialog = cart?.classList.contains('is-open') ? cart : gallery && !gallery.hidden ? gallery : drawer && !drawer.hidden ? drawer : quickView && !quickView.hidden ? quickView : search && !search.hidden ? search : null;
    if (!dialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const close = dialog.querySelector('.fv-mobile-drawer-close,button[data-close-quick],button[data-close-search],button[data-close-cart],button[data-close-gallery]');
      close?.click();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll(focusable)].filter(element => element.getClientRects().length && element.tabIndex >= 0);
    const first = controls[0];
    const last = controls.at(-1);
    if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      first?.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  }, { capture: true });
})();
